<template>
  <div id="comparison">
    <Details
      :range="range"
      :rangeCompetitor="rangeCompetitor"
      v-if="showDetails"
      @close="showDetails = false"
    ></Details>
    <div class="inline top">
      <div class="description">
        <div class="economy inline" :class="[{noeconomy: economy < 0 }]">
          <!-- <SvgIcon icon="economy" class="icon" v-if="economy > 0"></SvgIcon> -->
          <div class="amount" v-if="economy > 0">
            <span class="bold">{{ economy | toInteger }} €</span>
            {{ $t('comparison.product.economy') }}
          </div>
        </div>
        <table class="table" v-if="hasElec && elecProducts">
          <tr>
            <th>{{ $t('elec') }}</th>
          </tr>
          <tr>
            <td>{{ $t('comparison.product.subscription') }}</td>
          </tr>
          <tr v-for="meterType in elecMeterTypes" :key="meterType">
            <td>{{ $tc(meterType, elecMeterTypes.length) }}</td>
          </tr>
          <tr>
            <td>{{ $t('comparison.product.ecoTaxes') }}</td>
          </tr>
        </table>
        <table class="table" v-if="hasGas && gasProducts">
          <tr>
            <th>{{ $t('gas') }}</th>
          </tr>
          <tr>
            <td>{{ $t('comparison.product.subscription') }}</td>
          </tr>
          <tr>
            <td>{{ $t('comparison.product.consumption') }}</td>
          </tr>
        </table>
      </div>
      <div class="grow provider top left inline">
        <div class="col mega">
          <div class="logo">
            <img src="@/assets/logoMegaHeader.svg" />
          </div>
          <div class="total">{{ range.amounts.annual | toCurrency }} {{ $t('unity.annual') }}<sup v-if="!!findDiscountDD">**</sup></div>
          <table class="table" v-if="hasElec && elecProducts">
            <tr>
              <th>
                <select
                  class="product-select"
                  v-model="megaElecProduct"
                  @change="selectProduct(megaElecProduct)"
                >
                  <option
                    v-for="product in elecProducts.mega"
                    :key="product.name"
                    v-bind:value="product"
                  >{{ productName(product) }}</option>
                </select>
                <span v-if="megaElecProduct.contractType === 'variable'"
                      :class="isProductCDI(megaElecProduct) ? 'question-mark' : 'warning'"
                      @click="openModalHelp(megaElecProduct)"></span>
              </th>
            </tr>
            <tr>
              <td>{{ range.electricity.subscription[priceEuro] | toCurrency }} €</td>
            </tr>
            <tr v-for="meterType in elecMeterTypes" :key="meterType">
              <td>{{ range.electricity.energy[meterType][unitaryPriceEuro] * 100 | toCurrency }} c€</td>
            </tr>
            <tr>
              <td>{{ range.electricity.subtotal.renewable[unitaryPriceEuro] * 100 | toCurrency }} c€</td>
            </tr>
          </table>
          <table class="table" v-if="hasGas && gasProducts">
            <tr>
              <th>
                <select
                  class="product-select"
                  v-model="megaGasProduct"
                  @change="selectProduct(megaGasProduct)"
                >
                  <option
                    v-for="product in gasProducts.mega"
                    :key="product.name"
                    v-bind:value="product"
                  >{{ productName(product) }}</option>
                </select>
                <span v-if="megaGasProduct.contractType === 'variable'"
                      :class="isProductCDI(megaGasProduct) ? 'question-mark' : 'warning'"
                      @click="openModalHelp(megaGasProduct)"></span>
              </th>
            </tr>
            <tr>
              <td>{{ range.gas.subscription[priceEuro] | toCurrency }} €</td>
            </tr>
            <tr>
              <td>{{ range.gas.energy.day[unitaryPriceEuro] * 100 | toCurrency }} c€</td>
            </tr>
          </table>
        </div>
        <div class="col competitor">
          <div class="logo">
            {{ providerName }}
          </div>
          <div class="total">{{ rangeCompetitor.amounts.annual | toCurrency }} €/an</div>
          <table class="table" v-if="hasElec && elecProducts">
            <tr>
              <th>
                <select
                  class="product-select"
                  v-model="competitorElecProduct"
                  @change="selectProduct(competitorElecProduct)"
                >
                  <option
                    v-for="product in elecProductsMobile.competitor"
                    :key="product.id"
                    v-bind:value="product"
                  >{{ product[productNameTrad] }}</option>
                </select>
              </th>
            </tr>
            <tr>
              <td>{{ rangeCompetitor.electricity.subscription.priceEuroVAT | toCurrency }} €</td>
            </tr>
            <tr v-for="meterType in elecMeterTypes" :key="meterType">
              <td>{{ rangeCompetitor.electricity.energy[meterType].unitaryPriceEuroVAT * 100 | toCurrency }} c€</td>
            </tr>
            <tr>
              <td>{{ rangeCompetitor.electricity.subtotal.renewable.unitaryPriceEuroVAT * 100 | toCurrency }} c€</td>
            </tr>
          </table>
          <table class="table" v-if="hasGas && gasProducts">
            <tr>
              <th>
                <select
                  class="product-select"
                  v-model="competitorGasProduct"
                  @change="selectProduct(competitorGasProduct)"
                >
                  <option
                    v-for="product in gasProductsMobile.competitor"
                    :key="product.id"
                    v-bind:value="product"
                  >{{ product[productNameTrad] }}</option>
                </select>
              </th>
            </tr>
            <tr>
              <td>{{ rangeCompetitor.gas.subscription.priceEuroVAT | toCurrency }} €</td>
            </tr>
            <tr>
              <td>{{ rangeCompetitor.gas.energy.exclusiveDay.unitaryPriceEuroVAT * 100 | toCurrency }} c€</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="become" v-if="!noSubscribe">
      <a @click="redirect()" class="button">{{ $t('become') }}</a>
    </div>
    <button class="button secondary inverted" @click="showDetails = true">{{ $t('comparison.product.showDetail') }}</button>
    <div class="services">
      <p>{{ $tc(`Offer.Product.services.paymentModes`, megaProduct.paymentModes.length) }}</p>
      <p>{{ $tc(`Offer.Product.services.invoiceModes`, megaProduct.invoiceModes.length, {n: $t(`Offer.Product.services.paymentFrequencies.${megaProduct.paymentFrequencies[0]}`)})}}</p>
      <p>{{ $tc(`Offer.Product.services.serviceLevels`, megaProduct.serviceLevels.length) }}</p>
      <p v-if="isProductCDI">{{ $tc(`Offer.Product.services.isProductCDI`) }}</p>
      <p v-if="megaProduct.labels.isElectricityGreen">{{ $tc(`greenElec`) }}</p>
    </div>
    <WarningPrice v-if="showVariable" productCDI @close="showVariable = false"></WarningPrice>
    <div class="inline" v-if="!noSubscribe">
      <div class="mail inline space-around">
        <SendMail @send="sendMail()"></SendMail>
      </div>
      <div class="inline space-around" :class="$mq">
        <Print @generate="generatePdf()"></Print>
      </div>
    </div>
    <Informations></Informations>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Details from "../Details";
import Services from "../../components/Services";
import Select from "@/components/Select.vue";
import Informations from "../../components/Informations.vue";
import SendMail from "../../components/SendMail";
import Print from "../../components/Print";
import WarningPrice from "../../components/WarningPrice"
import productCDDorCDI from "@/mixins/productCDDorCDI";

export default {
  name: "Comparison-mobile",
  mixins: [productCDDorCDI],
  props: {
    range: null,
    rangeCompetitor: null,
    findDiscountDD: Number
  },
  data() {
    return {
      showDetails: false,
      showVariable: false,
    };
  },
  computed: {
    ...mapState("common", ["uuid", "agentJwt"]),
    ...mapState("contact", ["isPro"]),
    ...mapGetters("energy", ["hasElec", "hasGas"]),
    ...mapState("comparison", ["elecProducts", "gasProducts"]),
    ...mapGetters("consumption", ["elecMeterTypes"]),
    elecProductsMobile() {
      if (this.elecProducts) {
        let elecProducts = {
          mega: this.elecProducts.mega,
          competitor: this.elecProducts.competitor.filter(
            item => item.id !== "myElec"
          )
        };

        return elecProducts;
      }
    },
    gasProductsMobile() {
      if (this.gasProducts) {
        let gasProducts = {
          mega: this.gasProducts.mega,
          competitor: this.gasProducts.competitor.filter(
            item => item.id !== "myGas"
          )
        };
        return gasProducts;
      }
    },
    megaElecProduct: {
      get() {
        return this.$store.state.comparison.megaElecProduct;
      },
      set(value) {
        this.$store.commit("comparison/setMegaElecProduct", value);
      }
    },
    megaGasProduct: {
      get() {
        return this.$store.state.comparison.megaGasProduct;
      },
      set(value) {
        this.$store.commit("comparison/setMegaGasProduct", value);
      }
    },
    megaProduct() {
      return this.megaElecProduct || this.megaGasProduct;
    },
    competitorElecProduct: {
      get() {
        return this.$store.state.comparison.competitorElecProduct;
      },
      set(value) {
        this.$store.commit("comparison/setCompetitorElecProduct", value);
      }
    },
    competitorGasProduct: {
      get() {
        return this.$store.state.comparison.competitorGasProduct;
      },
      set(value) {
        this.$store.commit("comparison/setCompetitorGasProduct", value);
      }
    },
    economy() {
      return this.rangeCompetitor.amounts.annual - this.range.amounts.annual;
    },
    productNameTrad() {
      return this.$i18n.locale === "fr" ? "labelFr" : "labelNl";
    },
    amountType() {
      return this.isPro ? "amountHTVA" : "amountTVAC";
    },
    priceEuro() {
      return this.isPro ? "priceEuro" : "priceEuroVAT";
    },
    unitaryPriceEuro() {
      return this.isPro ? "unitaryPriceEuro" : "unitaryPriceEuroVAT";
    },
    noSubscribe() {
      return this.$router.currentRoute.query.noSubscribe !== undefined || this.$store.state.common.noSubscribe;
    },
    providerName() {
      let providerName = "";
      let locale = "";

      if(this.$i18n.locale === "fr")
        locale = "Fr";
      else if (this.$i18n.locale === "nl")
        locale = "Nl"

      if (this.elecProducts && this.elecProducts.competitor && this.elecProducts.competitor.length) {
        providerName = this.elecProducts.competitor[0][`competitor${locale}`];
        if (this.gasProducts && this.gasProducts.competitor && this.gasProducts.competitor.length
          && this.gasProducts.competitor[0][`competitor${locale}`] !== this.elecProducts.competitor[0][`competitor${locale}`])
          providerName += ' - ' + this.gasProducts.competitor[0][`competitor${locale}`];
      } else if(this.gasProducts && this.gasProducts.competitor && this.gasProducts.competitor.length)
        providerName = this.gasProducts.competitor[0][`competitor${locale}`];

      return providerName;
    }
  },
  methods: {
    async redirect() {
      let data = {
        uuid: this.uuid,
      };

      if (this.range.electricity) {
        this.range.electricity['wantGreen'] = this.wantGreen ? 1 : 0;
        data["megaProductElec"] = this.range.electricity;
      }

      if (this.range.gas) {
        this.range.gas['wantGreen'] = this.wantGreen ? 1 : 0;
        data["megaProductGas"] = this.range.gas;
      }

      console.log(data);

      try {
        await leadService.save(data);
      } catch (error) {
        console.log(error.response);
      }

      if(this.agentJwt)
        window.location.href = `${process.env.BECOME}/agent/?newSession&agent=${this.$route.query['agent']}&jwt=${this.agentJwt}&lead=${this.uuid}`;
      else
        window.location.href = `${process.env.BECOME}/lead/${this.uuid}?newSession`;
    },
    sendMail() {
      this.$store.dispatch("comparison/sendMail");

      if(this.$route.query["agent"]) {
        this.$router.push({name: "Energy", query: {...this.$route.query, newSession: true}});
      }
    },
    generatePdf() {
      this.$store.dispatch("comparison/generatePdf");
    },
    productName(product) {
      return this.$store.getters["comparison/productName"](
        product
      ).toUpperCase();
    },
    selectProduct(product) {
      this.$emit("selectProduct", product);
    }
  },
  filters: {
    toCurrency: function(value) {
      return parseFloat(value)
        .toFixed(2)
        .replace(".", ",");
    },
    toInteger: function(value) {
      return parseFloat(value).toFixed(0);
    }
  },
  watch: {
    // rangeCompetitor: function(oldValue, newValue) {
    //   console.log(newValue);
    //   if (oldValue.electricity.id !== newValue.electricity.id)
    //     this.$emit("selectProduct", this.range.electricity);
    // }
  },
  components: {
    Select,
    Services,
    Details,
    Informations,
    SendMail,
    Print,
    WarningPrice
  },
  created() {
    window.scrollTo(0, 0);
  }
};
</script>

<style lang="scss" scoped>
.product-select {
  width: 90px;
}

.description {
  width: 33%;

  .economy {
    margin: auto;
    width: 110px;
    height: 110px;
    z-index: 10;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    background: url("../../../assets/icons/icon-economy.svg") left;

    &.noeconomy {
      background: transparent;
    }

    .amount {
      width: 80px;
      font-size: 0.6rem;
      color: black;

      .bold {
        font-size: 1rem;
        font-weight: 500;
      }
    }
    .icon {
      font-size: 10rem;
    }
  }
  .table {
    th {
      background: white;
      color: #4d545a;
    }

    tr {
      background: $white;
      &:nth-child(even) {
        background: #eee;
      }
    }
  }
}

.table {
  width: 100%;
  border-collapse: collapse;

  th {
    height: 80px;
  }

  tr {
    td {
      height: 50px;
      font-size: 0.8rem;
    }
  }
}

.col {
  border-radius: 15px;
  width: 45%;
  padding-bottom: 15px;

  .total {
    font-weight: bold;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    min-height: 60px;
    padding: 5px;
  }

  &.mega {
    border-top: 10px solid #fdcb47;
    background: white;
    margin-right: 10px;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.4);

    .logo {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 5px 0;
      height: 30px;

      img {
        height: 70%;
      }
    }

    .total {
      background: #fdcb47;
    }

    .table {
      th {
        font-size: 0.9rem;
        select {
          font-weight: bold;
          border: 0;
          background: white;
        }
      }
      tr {
        background: $white;
        &:nth-child(even) {
          background: $clearYellow;
        }
      }
    }
  }

  &.competitor {
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.2);
    margin-top: 10px;
    background: $white;

    .logo {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 5px 0;
      height: 30px;
      font-size: 0.8rem;
      font-weight: bold;
    }

    .total {
      color: $black;
      background: $clearYellow;
    }

    .table {
      th {
        font-size: 0.9rem;
        font-weight: normal;
        select {
          font-weight: normal;
          border: 0;
          background: white;
        }
      }
      tr:nth-child(even) {
        background: $clearYellow;
      }
    }
  }
}

.details {
  cursor: pointer;
  border: 0;
  font-size: 1rem;
  padding: 10px 24px;
  font-family: "ObjectSans", Helvetica, Arial, sans-serif;
  text-decoration: underline $yellow;

  &.grey {
    color: #7a828c;
    border: 2px solid #7a828c;
  }
}

.become {
  padding: 20px;
  .button {
    cursor: pointer;
    font-weight: 600;
    margin: 0;
    padding: 10px 20px;
    font-size: 1.3rem;
    border: 0;
    background: #fdcb47;
    border-radius: 50px;
    box-shadow: 3px 6px 8px #fdcb475e;
  }
}

.services {
  font-size: 0.8rem;
  background: #fff;
  border-radius: 15px;
  border: 1px solid #fdcb47;
  margin-bottom: 10px;
  padding: 5px;

  p {
    text-align: left;
    margin: 10px;
  }

  &.grey {
    background: #e4e4e4;
  }
}


.warning {
  cursor: pointer;
  display: inline-block;
  height: 13px;
  width: 13px;
  background:url("~@/assets/icons/icon-warning.svg") no-repeat bottom/contain;
}

.disclaimer {
  margin: 1rem;
  font-size: 0.7rem;
}
</style>



// WEBPACK FOOTER //
// src/views/comparison/mobile/Comparison.vue